import { render, staticRenderFns } from "./personliablepopup.vue?vue&type=template&id=535028eb&scoped=true&"
import script from "./personliablepopup.vue?vue&type=script&lang=js&"
export * from "./personliablepopup.vue?vue&type=script&lang=js&"
import style0 from "./personliablepopup.vue?vue&type=style&index=0&id=535028eb&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535028eb",
  null
  
)

export default component.exports